export default __webpack_public_path__ + "static/media/swapnildhok.a60eff05.jpeg";